module.exports = __webpack_public_path__ + "media/images/version_merge/qr_code/crossed-e89e73f8dda80fe92817d5058af22572.png";